import {I18n} from 'aws-amplify/utils';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {NavLink} from 'react-router-dom';
import {Registrar} from '../types';
import {
    ActionIcon,
    Group
} from "@mantine/core";
import {AiOutlineLink} from "react-icons/ai";

export const columns = [
    {
        title: I18n.get('Name'),
        width: '1fr',
        render: (item: Registrar) => <NavLink to={`/registrars/${item.id}`}>{item.name}</NavLink>,
    },
    {
        title: I18n.get('Website'),
        width: '1fr',
        render: (item: Registrar) => <Group>{item.website} <ActionIcon variant={"subtle"}
                                                                       onClick={() => window.open(item.website)}>
            <AiOutlineLink/></ActionIcon></Group>,
    },
    {
        title: I18n.get('Created'),
        width: '1fr',
        render: (item: Registrar) => formatTimestamp(item.created as string),
    },
];
